import { ChevronLeft, Check } from "lucide-react";

export const OptionButton = ({ selected, onClick, children, testid, delay = 0, className = "" }) => (
    <button
        type="button"
        onClick={onClick}
        aria-pressed={selected}
        data-testid={testid}
        style={delay ? { animationDelay: `${delay}ms` } : undefined}
        className={`animate-fade-up min-h-[56px] px-4 rounded-[10px] border-[1.5px] text-[15px] md:text-base font-semibold text-navy transition-[border-color,background-color,transform] duration-200 hover:-translate-y-[1px] ${
            selected ? "border-gold-dark bg-sand" : "border-border-default bg-white hover:border-navy"
        } ${className}`}
    >
        {children}
    </button>
);

export const CheckOption = ({ checked, onClick, children, testid }) => (
    <button
        type="button"
        onClick={onClick}
        aria-pressed={checked}
        data-testid={testid}
        className={`w-full min-h-[52px] px-4 rounded-[10px] text-left text-[15px] font-semibold text-navy flex items-center gap-3 transition-colors ${
            checked ? "border-2 border-navy bg-sand" : "border-[1.5px] border-border-default bg-white hover:border-navy"
        }`}
    >
        <span className={`w-5 h-5 rounded-[5px] shrink-0 flex items-center justify-center ${checked ? "bg-navy text-white" : "border-[1.5px] border-border-stronger"}`}>
            {checked && <Check size={14} strokeWidth={3} />}
        </span>
        {children}
    </button>
);

export const SimProgress = ({ step, onBack }) => (
    <div className="flex flex-col gap-4 mb-6">
        <div className="flex items-center justify-between min-h-[44px]">
            {onBack ? (
                <button type="button" onClick={onBack} aria-label="Question précédente" data-testid="sim-back" className="w-11 h-11 -ml-3 flex items-center justify-center text-navy rounded-md hover:bg-sand transition-colors">
                    <ChevronLeft size={22} />
                </button>
            ) : <span />}
            <span className="text-sm text-grey-text-soft" data-testid="sim-step-label">Question {step} sur 3</span>
        </div>
        <div role="progressbar" aria-valuemin={0} aria-valuemax={3} aria-valuenow={step} aria-label="Progression" className="h-1.5 rounded-full bg-border-soft overflow-hidden">
            <div className="h-full bg-gold rounded-full transition-[width] duration-500" style={{ width: `${(step / 3) * 100}%` }} />
        </div>
    </div>
);

export const NotedBanner = ({ children }) =>
    children ? (
        <div data-testid="sim-noted" className="bg-sand rounded-[10px] px-4 py-3.5 text-[15px] leading-normal text-navy mb-5 animate-fade-up">
            {children}
        </div>
    ) : null;

export const QuestionTitle = ({ children }) => (
    <h2 className="m-0 text-xl md:text-[26px] font-bold leading-[1.3] tracking-[-0.015em] text-navy">{children}</h2>
);
